import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import { Forecast } from 'components/common/Elements/Elements';

const Widgets = ({ wData }) => {
  const { t } = useTranslation(['activity']);

  const data = [
    {
      header: t('activity:features.DEPTH_ADOPTION'),
      amount: wData.depthOfAdop,
      type: '%',
      tooltip: t('activity:features.DEPTH_ADOPTION_TOOLTIP')
    },
    {
      header: t('activity:features.DURATION_ADOPTION'),
      amount: wData.avgDurOfAdop,
      type: 'days',
      tooltip: t('activity:features.DURATION_ADOPTION_TOOLTIP')
    },
    {
      header: t('activity:features.TIME_ADOPTION'),
      amount: wData.timeForAdop,
      type: 'days',
      tooltip: t('activity:features.TIME_ADOPTION_TOOLTIP')
    },
    {
      header: t('activity:features.MAU_RATE'),
      amount: wData.mauRate,
      type: '%',
      tooltip: t('activity:features.MAU_RATE_TOOLTIP')
    }
  ];
  return <Forecast data={data} />;
};

Widgets.propTypes = {
  wData: PropTypes.shape({
    depthOfAdop: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    avgDurOfAdop: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    timeForAdop: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    mauRate: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })
};

export default Widgets;
